export enum SubstringStartIndexOptions {
	StaticValue = 1,
	FirstIndexOf = 2,
	LastIndexOf = 3,
}
